import useChatStore, { COLUMNS, GRID, ROWS, TABS } from 'Components/Chat/store';
import { useChatMessagesContext } from 'Context/Chat/ChatMessagesContext';

const GridContainer = ({ children }) => {
  const renderType = useChatStore((state) => state.renderType);
  const { streamingMessage } = useChatMessagesContext();

  const getGridCols = () => {
    switch (renderType) {
      case COLUMNS:
        return 'grid-cols-' + streamingMessage.length;
      case GRID:
        return streamingMessage.length >= 2 ? 'grid-cols-2' : '';
      default:
        return 'grid-cols-1';
    }
  };

  const centerMessage = (item) => {
    return (
      renderType === TABS ||
      renderType === ROWS ||
      !Array.isArray(item) ||
      (Array.isArray(item) && item?.length === 1)
    );
  };

  return (
    <div
      className={`w-full h-full m-auto px-8 grid gap-5 scrollbar-hidden ${getGridCols()} ${
        centerMessage(streamingMessage) && 'lg:max-w-4xl m-auto'
      }`}
    >
      {children}
    </div>
  );
};

export default GridContainer;
